const getDefaultDataUser = () => ({
  token: '',
  empresa: '',
  nome_usuario: '',
  id_funcao: '0',
  nome_fantasia: '',
  site: '',
});

const MAX_HUMAN_SUPPORT_NOTIFICATION_COUNT = 9;

const persistEmpresas = (empresas) => {
  localStorage.setItem('empresas', JSON.stringify(empresas || []));
};

const persistEmpresaAtiva = (empresa) => {
  if (!empresa) {
    return;
  }

  const userToken = empresa.key || '';
  const empresaToken = empresa.token || '';

  localStorage.setItem('key', userToken);
  localStorage.setItem('token', empresaToken);
  localStorage.setItem('email', empresa.email || '');
  localStorage.setItem('title', `Bot - ${empresa.nome_fantasia}`);
  window.document.title = `Bot - ${empresa.nome_fantasia}`;
};

const normalizeEmpresa = (empresa, response, index) => {
  const dados = response.data.dados;
  const bandeiras = response.data.bandeiras || dados.bandeiras;
  const userToken = empresa.key || '';
  const empresaToken = response.data.empresa || dados.token || empresa.token || '';
  const xAuth = response.data.x_auth ? `Bearer ${response.data.x_auth}` : (empresa.x_auth || '');

  return {
    ...empresa,
    key: userToken,
    bandeiras: bandeiras ? bandeiras.map((b) => b.id_empresa) : null,
    nome_fantasia: dados.nome_fantasia,
    telefone: `55${dados.telefone}`,
    img_empresa: dados.url_imagem,
    id_usuario: dados.id_usuario,
    id_empresa: dados.id_empresa,
    nome_usuario: dados.nome,
    site: dados.site,
    email: dados.email,
    token: empresaToken,
    x_auth: xAuth,
    wpp: index + 1,
    atendimentos: empresa.atendimentos || [],
    atendimentosVisualizados: empresa.atendimentosVisualizados || [],
  };
};

const normalizeEmpresasDefault = (empresas = []) => {
  if (!empresas.length) {
    return [];
  }

  const defaultIndex = empresas.findIndex((empresa) => empresa.isDefault);
  const selectedIndex = defaultIndex >= 0 ? defaultIndex : 0;

  return empresas.map((empresa, index) => ({
    ...empresa,
    isDefault: index === selectedIndex,
  }));
};

export const authState = {
  dataUser: getDefaultDataUser(),
  wpp_session: [],
  canPlay: false,
  isReady: false,
  config: { version: null, pauseWpp: 2 },
  version: 0,
  session: null,
  empresas: [],
};

const sameWppSession = (current, next) => {
  if (!current || !next) {
    return false;
  }

  if (current.id_empresa && next.id_empresa) {
    return String(current.id_empresa) === String(next.id_empresa);
  }

  if (current.token && next.token) {
    return String(current.token) === String(next.token);
  }

  return false;
};

const normalizeWppSessions = (sessions = []) => {
  return sessions.reduce((acc, session) => {
    const index = acc.findIndex((current) => sameWppSession(current, session));

    if (index >= 0) {
      acc.splice(index, 1, {
        ...acc[index],
        ...session,
      });
      return acc;
    }

    acc.push(session);
    return acc;
  }, []);
};

const isSameEmpresa = (left, right) => String(left || '') === String(right || '');

const getEmpresaAtiva = (empresas = []) => {
  return empresas.find((empresa) => empresa.isDefault) || null;
};

const getAtendimentosCount = (empresa) => {
  const total = empresa && empresa.atendimentos
    ? empresa.atendimentos.length
    : 0;

  return total > MAX_HUMAN_SUPPORT_NOTIFICATION_COUNT
    ? MAX_HUMAN_SUPPORT_NOTIFICATION_COUNT
    : total;
};

const syncAtendimentosState = (state) => {
  const empresaAtiva = getEmpresaAtiva(state.empresas);
  const total = getAtendimentosCount(empresaAtiva);

  state.atendimentos = {
    status: total > 0,
    total,
  };

  const title = localStorage.getItem('title');

  if (title) {
    window.document.title = title + (total > 0 ? ` (${total})` : '');
  }
};

export const authMutations = {
  setDataUser: (state, data) => {
    const dados = data.dados;
    const master = parseInt(dados.master || '0', 10) > 0;

    state.dataUser = {
      ...dados,
      master,
      admin: (dados.id_funcao <= '1'),
      isGarcom: (dados.id_funcao === '3'),
      entregadores: data.entregadores && data.entregadores.length ? data.entregadores : null,
      empresa: data.empresa || data.dados.token || state.dataUser.empresa || '',
    };
  },

  SET_EMPRESAS(state, empresas) {
    state.empresas = empresas || [];
    syncAtendimentosState(state);
  },
  SET_CAN_PLAY(state, canPlay) {
    state.canPlay = canPlay;
  },

  SET_IS_READY(state, isReady) {
    state.isReady = isReady;
  },

  SET_VERSION(state, version) {
    state.version = version;
  },

  SET_WPP_SESSION(state, sessions) {
    state.wpp_session = normalizeWppSessions(sessions);
  },

  ADD_WPP_SESSION(state, session) {
    const index = state.wpp_session.findIndex((current) => sameWppSession(current, session));

    if (index >= 0) {
      state.wpp_session.splice(index, 1, {
        ...state.wpp_session[index],
        ...session,
      });
      return;
    }

    state.wpp_session.push(session);
  },

  SET_SESSION(state, session) {
    state.session = session || null;
  },

  SET_CONFIG(state, config) {
    state.config = config || { version: null, pauseWpp: 2 };
  },

  SYNC_ATENDIMENTOS(state) {
    syncAtendimentosState(state);
  },
};

export const authActions = {
  hydrateEmpresas({ commit }, { parseJSONObject }) {
    let empresas = parseJSONObject(localStorage.getItem('empresas'));
    const token = localStorage.getItem('key');

    if (!empresas && token) {
      empresas = [{ key: token, token: localStorage.getItem('token') || '', isDefault: true }];
    }

    empresas = (empresas || []).map((empresa) => {
      return {
        ...empresa,
        key: empresa.key || '',
        token: empresa.token || '',
        x_auth: empresa.x_auth || '',
        atendimentos: empresa.atendimentos || [],
        atendimentosVisualizados: empresa.atendimentosVisualizados || [],
      };
    });

    empresas = normalizeEmpresasDefault(empresas);

    commit('SET_EMPRESAS', empresas || []);
    return empresas || [];
  },

  async autenticarEmpresa({ commit, state }, { http, baseServer, index }) {
    const empresa = state.empresas[index];

    if (!empresa) {
      return { success: false };
    }

    try {
      const response = await http.post(`${baseServer}auth/v2/me`, {
        token: empresa.key
      });

      if (!response.data.success) {
        return { success: false };
      }

      const authenticatedEmpresa = normalizeEmpresa(empresa, response, index);
      const empresas = state.empresas.map((current, currentIndex) => (
        currentIndex === index ? authenticatedEmpresa : current
      ));
      const statusEmpresa = response.data.dados.status_empresa || '2';
      const habilitarLebot = response.data.dados.habilitar_lebot || '1';
      const deveAtivarContexto = authenticatedEmpresa.isDefault || statusEmpresa !== '2' || habilitarLebot !== '1';

      commit('SET_EMPRESAS', empresas);

      if (deveAtivarContexto) {
        persistEmpresaAtiva(authenticatedEmpresa);
        commit('setDataUser', response.data);
      }

      return {
        success: true,
        response,
        empresa: authenticatedEmpresa,
        statusEmpresa,
        habilitarLebot,
      };
    } catch (error) {
      if (error && error.status === 401) {
        const empresas = state.empresas.filter((current) => current.key !== empresa.key);
        commit('SET_EMPRESAS', empresas);
        persistEmpresas(empresas);

        return { success: false, unauthorized: true };
      }

      throw error;
    }
  },

  finalizeEmpresas({ commit, state }) {
    if (!state.empresas.length) {
      persistEmpresas([]);
      return [];
    }

    const empresas = normalizeEmpresasDefault(state.empresas);

    commit('SET_EMPRESAS', empresas);
    persistEmpresas(empresas);

    return empresas;
  },

  selectEmpresa({ commit, state }, conta) {
    const empresas = state.empresas.map((empresa) => ({
      ...empresa,
      isDefault: isSameEmpresa(empresa.id_empresa, conta.id_empresa),
    }));
    const empresaAtiva = empresas.find((empresa) => isSameEmpresa(empresa.id_empresa, conta.id_empresa)) || conta;
    const session = state.wpp_session.find((wpp) => isSameEmpresa(wpp.id_empresa, conta.id_empresa)) || null;

    commit('SET_EMPRESAS', empresas);
    commit('SET_SESSION', session);
    persistEmpresas(empresas);
    persistEmpresaAtiva(empresaAtiva);
    commit('SYNC_ATENDIMENTOS');
  },

  setAtendimentosEmpresas({ commit, state }, atendimentos) {
    const empresas = state.empresas.map((empresa) => ({
      ...empresa,
      atendimentos: atendimentos.filter((item) => {
        const visualizadas = empresa.atendimentosVisualizados || [];
        return item.id_empresa === empresa.id_empresa && !visualizadas.includes(item.id_chatbot_user);
      }),
      atendimentosVisualizados: (empresa.atendimentosVisualizados || [])
        .filter((idChatbotUser) => {
          return atendimentos.some((item) => (
            item.id_empresa === empresa.id_empresa && item.id_chatbot_user === idChatbotUser
          ));
        }),
    }));

    commit('SET_EMPRESAS', empresas);
    persistEmpresas(empresas);
  },

  clearAtendimentosEmpresa({ commit, state }, idEmpresa) {
    const empresas = state.empresas.map((empresa) => {
      if (!isSameEmpresa(empresa.id_empresa, idEmpresa)) {
        return empresa;
      }

      const idsVisualizados = [
        ...(empresa.atendimentosVisualizados || []),
        ...(empresa.atendimentos || []).map((item) => item.id_chatbot_user),
      ];

      return {
        ...empresa,
        atendimentos: [],
        atendimentosVisualizados: [...new Set(idsVisualizados)],
      };
    });

    commit('SET_EMPRESAS', empresas);
    persistEmpresas(empresas);
  },

  removeAtendimentoEmpresa({ commit, state }, { idEmpresa, idChatbotUser }) {
    const empresas = state.empresas.map((empresa) => {
      if (!isSameEmpresa(empresa.id_empresa, idEmpresa)) {
        return empresa;
      }

      return {
        ...empresa,
        atendimentos: (empresa.atendimentos || [])
          .filter((item) => item.id_chatbot_user !== idChatbotUser),
        atendimentosVisualizados: (empresa.atendimentosVisualizados || [])
          .filter((currentId) => currentId !== idChatbotUser),
      };
    });

    commit('SET_EMPRESAS', empresas);
    persistEmpresas(empresas);
  },

  restoreWppSessions({ commit, dispatch }) {
    const session = sessionStorage.getItem('wpp_session');
    const sessions = session ? JSON.parse(session) || [] : [];

    commit('SET_WPP_SESSION', sessions);
    dispatch('syncSessionAtual');
    return sessions;
  },

  addWppSession({ commit, dispatch, state }, data) {
    commit('ADD_WPP_SESSION', data);
    sessionStorage.setItem('wpp_session', JSON.stringify(state.wpp_session));

    dispatch('syncSessionAtual');
  },

  syncSessionAtual({ commit, state }) {
    const empresaDefault = state.empresas.find((empresa) => empresa.isDefault);
    const session = state.wpp_session.find((wpp) => isSameEmpresa(wpp.id_empresa, (empresaDefault || {}).id_empresa)) || null;
    commit('SET_SESSION', session);
    return session;
  },
};
